<template>
  <div class="pie-chart" ref="chart"></div>
</template>

<script>
export default {
  name: "BasePie",
  props: {
    chartData: {
      type: Array,
      required: true,
    },
    chartTotal: {
      type: Number,
      required: true,
    },
    chartName: {
      type: String,
      required: true,
    },
    color: {
      type: Array,
      required: false,
    },
    legend: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      myChart: "",
    }
  },
  created() {
    let _this = this
    setTimeout(() => {
      _this.initCharts()
      //this.myChart.hideLoading()
    }, 1000)
  },
  methods: {
    initCharts() {
      console.log(this.chartData)
      let _this = this
      _this.myChart.setOption({
        // backgroundColor: "gray",
        tooltip: {
          trigger: "item",
          formatter: "{b}<br/> {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          data: this.legend,
          left: 10,

          textStyle: {
            //文字颜色
            fontSize: 14,
            color: "#333",
          },
          itemWidth: 30, //图标宽
          itemHeight: 20, //图标高
          itemGap: 13, //间距
        },
        color: _this.color,
        grid: {
          bottom: "20%",
          top: "20%",
          left: "20%",
          right: "20%",
        },
        series: [
          {
            type: "pie",
            radius: ["50%", "70%"],
            label: {
              normal: {
                show: true,
                position: "center",
                formatter: function() {
                  return _this.chartName + "\r\n" + _this.chartTotal
                },
                textStyle: {
                  fontSize: 26,
                  color: "#333",
                  lineHeight: 32,
                },
              },
            },
            labelLine: {
              show: false,
            },
            data: _this.chartData,
          },
        ],
      })
      _this.myChart.hideLoading()
      window.addEventListener("resize", () => {
        _this.myChart.resize()
      })
    },
  },
  mounted() {
    //加loading效果
    this.myChart = this.$echarts.init(this.$refs.chart)
    this.myChart.showLoading()
    // this.myChart.showLoading({
    //   text: "loading",
    //   color: "#c23531",
    //   textColor: "#000",
    //   maskColor: "rgba(255, 255, 255, 0.2)",
    //   zlevel: 0,
    // })
  },
}
</script>

<style lang="scss" scoped>
.pie-chart {
  width: 80%;
  height: 560px;
}
</style>
